import styled from 'styled-components';

export const StyledButtonContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
`;
